import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import React, { Component } from 'react';
import { FormattedNumber, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import FormattedInputField from "../../sharedComponents/formattedInputField.component.jsx";
import { putPricingTableItemDiscount, setPricingTableTotals } from '../../state/pricing/actions';
import { getPricingTableId, getPricingTableItem } from '../../state/pricing/selectors';
import GlobalHelper from "../GlobalHelper.jsx";
import Icon from "../icon/icon.component.jsx";
const uuidv4 = require('uuid/v4')

class QuoteItemDiscount extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            item: this.props.item || null,
            type: this.props.type || 'quote',
            currency: this.props.currency,
            uniqueId: uuidv4(),
            selectOptions: {
                "percent-before-taxes": "%",
                "currency-value": this.props.currency,
            },
            discountValue: this.props.item ? this.props.item.attributes.discountValue : '0',
            discountType: this.props.item ? this.props.item.attributes.discountType : 'percent-before-taxes',
            editable: this.props.editable || false,
            title: this.props.title || '',
            editMode: false,
            mainObjectId: this.props.mainObjectId || '',
        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.save = this.save.bind(this)
        this.remove = this.remove.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            item: nextProps.item,
            currency: nextProps.currency,
            discountType: nextProps.item?.attributes.discountType,
            discountValue: nextProps.item?.attributes.discountValue,
            type: nextProps.type || 'quote',
            selectOptions: {
                "percent-before-taxes": "%",
                "currency-value": nextProps.currency,
            },
            editable: nextProps.editable,
            mainObjectId: nextProps.mainObjectId || '',
        })
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    remove(event) {
        this.save(event, 'none', '0')
    }

    save(event, type, value) {
        event.preventDefault()
        let discountType = this.state.discountType
        let discountValue = this.state.discountValue
        if (type) {
            discountType = type
        }
        if (value) {
            discountValue = value
        }
        if (parseFloat(this.state.discountValue) === 0) {
            discountType = 'none'
        }

        this.props.putPricingTableItemDiscount(this.props.itemId, this.props.mainObjectId, this.props.type, {
            discountType: discountType,
            discountValue: discountValue,
            mainObjectId: this.state.mainObjectId,
        }).then(() => {
            this.setState({
                editMode: false,
                discountType: discountType,
                discountValue: discountValue,
            }, () => this.props.setPricingTableTotals(this.props.mainObjectId, this.props.pricingTableId, this.props.type, true, true))
        })
    }

    handleFocus(event) {
        event.target.select()
    }

    render() {
        if (!this.state.item) {
            return ''
        }

        let discount = ''
        let discountValue = ''
        if (this.state.item.attributes.discountValue != 0) {
            if (this.state.discountType === 'currency-value') {
                discountValue = <FormattedNumber
                    style="currency"
                    currency={this.state.currency}
                    value={-this.state.item.attributes.discountValue}
                />
            } else {
                discountValue = <FormattedNumber
                    style="percent"
                    value={-(parseFloat(this.state.item.attributes.discountValue) / 100)}
                    maximumFractionDigits={2}
                />
            }
            discount = discountValue
        }

        if (this.state.editable) {
            discount = <>
                <button id={this.props.isPricingTable ? "unitDiscountItem" : ""}
                    title={this.state.title} type="button" className="btn btn-sm btn-outline-primary" aria-expanded="false"
                    onClick={this.triggerEdit} disabled={!this.state.editable}
                    style={{ overflow: "hidden" }}
                >
                    {this.state.item.attributes.discountValue != 0 ? discountValue : <Icon value="tag" />}
                </button>
                <div style={this.props.dropdownStyle} className={"dropdown-menu p-4 " + (this.state.editMode ? 'show' : '')}>
                    <p className="m-0">
                        <FormattedInputField
                            type="text"
                            className="form-control"
                            aria-label={'Discount value'}
                            placeholder={GlobalHelper.applyLocaleDecimal("0.00", AppContext.getLocale().getLanguage())}
                            onFocus={this.handleFocus}
                            valueType="decimal"
                            value={this.state.discountValue}
                            onValueChange={(newValue) => {
                                let discountType = this.state.discountType
                                if (!discountType || discountType === 'none') {
                                    discountType = 'percent-before-taxes'
                                }
                                this.setState({ discountValue: newValue, discountType: discountType })
                            }}
                        />
                    </p>
                    <p className="m-0 pt-2">
                        <select value={this.state.discountType}
                            className="custom-select"
                            onChange={(event) => { this.setState({ discountType: event.target.value }) }}
                        >
                            {Object.entries(this.state.selectOptions).map(([key, value]) => <option key={key} id={key} value={key}>{value}</option>)}
                        </select>
                    </p>
                    <p className="m-0 pt-2">
                        <button title={'Cancel discount'} className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        {this.state.item.attributes.discountValue != 0 ? <button title={'Remove discount'} className="btn btn-sm btn-outline-danger ml-2" onClick={this.remove}>
                            <Icon value={"trash"} />
                        </button> : ''}
                        <button title={'Save discount'} className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                            <Icon value={"save"} />
                        </button>
                    </p>
                </div>
            </>
        }

        return discount
    }

}

const mapState = (state, props) => {
    const id = props.itemId
    const objectId = props.mainObjectId
    const item = getPricingTableItem(state, id, objectId)
    return {
        ...props,
        item: item,
        pricingTableId: getPricingTableId(state, props.mainObjectId)
    }
}
const mapDispatch = { putPricingTableItemDiscount, setPricingTableTotals }
export default connect(mapState, mapDispatch)(injectIntl(QuoteItemDiscount))





// WEBPACK FOOTER //
// ./src/common/quote/itemdiscount.component.jsx